import { render } from "./KeyResultsTable.vue?vue&type=template&id=3d9624ea&scoped=true"
import script from "./KeyResultsTable.vue?vue&type=script&lang=js"
export * from "./KeyResultsTable.vue?vue&type=script&lang=js"

import "./KeyResultsTable.vue?vue&type=style&index=0&id=3d9624ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9624ea"]])

export default __exports__